
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Anne-Lise Cornu, 69 ans, décédée le 7 avril 2020</b>
    <br />
    <br />
    <i>Céline Fleury-Cornu, sa fille, se souvient: </i>
    <br />
    <p>
  «Le 26 mars, notre père, Henri-Paul, est mort du Covid-19. Ma mère, Anne-Lise,
  est restée seule dans son appartement, à Romont (FR). Nous pensions qu’elle
  pouvait avoir été aussi infectée. Mais dans les jours qui ont suivi, elle
  disait se sentir bien physiquement. Le 3 avril, les premiers symptômes sont
  apparus. Une nièce qui lui avait parlé au téléphone a remarqué qu'elle avait
  des difficultés respiratoires. Comme notre père peu avant, elle a alors été
  admise à l'hôpital cantonal de Fribourg. Elle n’a pas été placée aux soins
  intensifs, mais bénéficiait quand même d’une aide respiratoire. Malgré son
  état de santé, elle disait être impatiente de rentrer chez elle. Au téléphone,
  je ne pouvais pas lui dire la vérité. Je savais déjà que je ne pourrai plus
  jamais la prendre dans mes bras. Cela me dérange encore aujourd’hui de ne pas
  avoir pu le faire. Je vivais à Zurich avec ma famille. Un voyage dans le
  canton de Fribourg me semblait risqué à l’époque. A cette époque, mon frère
  cadet, Didier, était aussi aux soins intensifs dans le même hôpital et
  toujours à cause du Covid-19. Il a été intubé le jour où maman est morte. Ce
  décès m’a attristé. Mais il a été aussi un soulagement. Elle s’est endormie
  paisiblement, sans anxiété. Mon frère s'est réveillé de son coma artificiel
  après 17 jours. Comme par miracle, selon les médecins. Quand je repense à ce
  printemps 2020, je ressens encore de l’impuissance. Cela m’a personnellement
  transformée. Je ne fais plus de plan à long terme. Le processus de deuil est
  lent et pénible, notamment parce que nous n'avons pas encore pu enterrer nos
  parents. Avec un peu de chance, nous pourrons le faire au printemps prochain.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;